
import CustomDrawer from './CustomDrawer.vue';
import CloseIcon from '../icons/CloseIcon.vue';
import InfoIcon from '../icons/InfoIcon.vue';

export default {
  name: 'PortfolioCreationDateInfoDrawer',
  components: { CustomDrawer, CloseIcon, InfoIcon },

  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    handleCloseDrawer() {
      this.$emit('closeDrawer');
    },
  },
};
